export const ORDER_TYPE_MAPPER = {
  REDEEM: 'redeem',
  SWITCH: 'switch',
  STP: 'stp',
  SWP: 'swp',
}